/** @format */

import {ToggleButtonGroupProps} from '@mui/material';

import {ToggleOption} from './types';
import {Root, StyledToggleButton} from './styles';

type Props<V extends string> = {
  value: V | V[] | null;
  onChange: (next: V | V[] | null) => void;
  options: ToggleOption<V>[];
  multiple?: boolean;
  disabled?: boolean;
} & ToggleButtonGroupProps;

const CustomToggleButtonGroup = <V extends string>({
  value,
  onChange,
  options,
  multiple = false,
  disabled,
  ...props
}: Props<V>) => {
  const handleChange = (_: React.MouseEvent<HTMLElement>, nextValue: V | V[] | null) => {
    onChange(nextValue);
  };

  return (
    <Root
      value={value ?? (multiple ? [] : null)}
      exclusive={!multiple}
      onChange={handleChange}
      {...props}
    >
      {options.map(option => (
        <StyledToggleButton key={option.value} value={option.value} disabled={disabled}>
          {option.label}
        </StyledToggleButton>
      ))}
    </Root>
  );
};

export {CustomToggleButtonGroup};
